import React, { useMemo } from 'react'
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles'
import LinkComponent from './LinkComponent';
import RouteLinkComponent from './RouteLinkComponent';
import { ROUTES } from '../constants/routes';

const useStyles = makeStyles((theme) => ({
    link: {
        color: theme.palette.primary.main,
        fontSize: 14,
        marginTop: 5
    },
    title: {
        color: theme.palette.primary.main,
        fontWeight: 550,
        fontSize: 15
    },
    container: {
        padding: '20px 5px',
        [theme.breakpoints.down('xs')]: {
            padding: '10px 0',
        }
    }
}))

const FooterColumnComponent = ({ slash = '/', title, externalLink, anchor, pageLink, slug = '#', links = [], children, lg = 2, xs = 6 }) => {
    const classes = useStyles();
    const to = useMemo(() => {
        if (externalLink){
            return slug 
        } else if (anchor){
            const url = new URL(`${window.location.origin}${slug}`);
            return url.pathname === window.location.pathname ? url.hash : slug;
        }
        return false
    }, [externalLink, anchor, slug])
    return (
        <Grid item className={classes.container} lg={lg} md={4} xs={xs}>
            {slug !== '#'
                ? <RouteLinkComponent
                    to={externalLink || anchor ? false : `${pageLink ? ROUTES['page'] : ''}${slash}${slug}`}
                    href={to}
                    hiddenBlank={anchor}
                >
                    {<Typography variant='h6' className={classes.title}>{title}</Typography>}
                </RouteLinkComponent>
                : <Typography variant='h6' className={classes.title}>{title}</Typography>
            }
            {links.length
                ? <Box mt='20px'>
                    {links.map(({ name, slug, external_link, page_link }, index) =>
                        <LinkComponent
                            key={index}
                            extrLink={external_link}
                            title={name}
                            href={slug}
                            pageLink={page_link}
                            className={classes.link}
                        />
                    )}
                </Box>
                : ''}
            {children
                ? <Box mt='20px'>
                    {children}
                </Box>
                : ''}

        </Grid>
    )
}


export default React.memo(FooterColumnComponent);